<div class="professional-report-builder">
  <div class="prb-header mb-25">
    <div class="prb-header__content">
      <div class="prb-header__title">
        <div class="prb-header__icon">
          <mat-icon>assessment</mat-icon>
        </div>
        <div class="prb-header__meta">
          <h4 class="mb-0">Construtor de Relatório</h4>
          <p class="mb-0">Profissionais • filtros • exportação Excel</p>
        </div>
      </div>

      <div class="prb-header__chips">
        <mat-chip class="prb-chip" disableRipple>
          <mat-icon>groups</mat-icon>
          Total: {{ totalProfessionals }}
        </mat-chip>
        <mat-chip class="prb-chip" disableRipple>
          <mat-icon>view_column</mat-icon>
          Campos: {{ getSelectedFieldsCount() }}
        </mat-chip>
        <mat-chip class="prb-chip prb-chip--status" disableRipple>
          <mat-icon>filter_alt</mat-icon>
          Status: {{ getSelectedStatusLabel() }}
        </mat-chip>
      </div>
    </div>

    <mat-progress-bar *ngIf="loading" mode="indeterminate" class="prb-header__loader"></mat-progress-bar>
  </div>

  <div class="prb-grid mb-25">
    <mat-card class="tagus-card prb-card">
      <mat-card-header class="border-bottom prb-card__header">
        <h5 class="mb-0">Filtros</h5>
      </mat-card-header>
      <mat-card-content class="prb-card__content">
        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Status do profissional</mat-label>
          <mat-select [(value)]="selectedStatus" (selectionChange)="onStatusChange()">
            <mat-option *ngFor="let option of statusOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Vínculo Trabalhista</mat-label>
          <mat-select [(value)]="selectedEmploymentType" (selectionChange)="onEmploymentTypeChange()">
            <mat-option *ngFor="let option of employmentTypeOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="w-100">
          <mat-label>Situação</mat-label>
          <mat-select [(value)]="selectedIsActive" (selectionChange)="onIsActiveChange()">
            <mat-option *ngFor="let option of isActiveOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div class="prb-hint">
          Use o filtro para gerar e exportar apenas os profissionais desejados.
        </div>
      </mat-card-content>
    </mat-card>

    <mat-card class="tagus-card prb-card">
      <mat-card-header class="border-bottom prb-card__header">
        <h5 class="mb-0">Ações</h5>
      </mat-card-header>
      <mat-card-content class="prb-card__content">
        <div class="prb-actions">
          <button mat-stroked-button class="tagus" (click)="selectAllFields()">
            <mat-icon>select_all</mat-icon>
            Selecionar
          </button>

          <button mat-stroked-button class="tagus" (click)="deselectAllFields()">
            <mat-icon>deselect</mat-icon>
            Limpar
          </button>

          <button
            mat-raised-button
            class="tagus"
            (click)="exportToExcel()"
            [disabled]="loading || getSelectedFieldsCount() === 0"
          >
            <mat-icon>file_download</mat-icon>
            Exportar Excel
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <!-- Seleção de Campos -->
  <mat-card class="tagus-card mb-25 prb-card">
    <mat-card-header class="border-bottom prb-card__header prb-card__header--with-actions">
      <div class="left">
        <h5 class="mb-0">Campos do relatório</h5>
        <span class="sub">Selecione o que vai para a planilha</span>
      </div>
      <div class="right">
        <mat-form-field appearance="fill" class="prb-field-search">
          <mat-icon matPrefix>search</mat-icon>
          <mat-label>Buscar campo</mat-label>
          <input matInput [(ngModel)]="fieldSearch" placeholder="Ex: CRM, especialidade, telefone" />
        </mat-form-field>
        <mat-chip class="prb-chip prb-chip--muted" disableRipple>
          Selecionados (filtro): {{ getSelectedFieldsCountFiltered() }}
        </mat-chip>
      </div>
    </mat-card-header>
    <mat-card-content class="prb-card__content">
      <div class="prb-fields-grid" *ngIf="filteredFields.length; else emptyFields">
        <label class="prb-field" *ngFor="let field of filteredFields">
          <mat-checkbox [(ngModel)]="field.selected" (change)="onFieldSelectionChange()">
            <span class="prb-field__label" [matTooltip]="field.key">{{ field.header }}</span>
          </mat-checkbox>
        </label>
      </div>

      <ng-template #emptyFields>
        <div class="prb-empty">
          <mat-icon>search_off</mat-icon>
          <div>
            <h6 class="mb-0">Nenhum campo encontrado</h6>
            <p class="mb-0">Tente buscar por outro termo.</p>
          </div>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>

  <!-- Preview dos Dados -->
  <mat-card class="tagus-card prb-card">
    <mat-card-header class="border-bottom prb-card__header prb-card__header--with-actions">
      <div class="left">
        <h5 class="mb-0">Pré-visualização</h5>
        <span class="sub">Veja exatamente o que será exportado</span>
      </div>
      <div class="right">
        <mat-chip class="prb-chip prb-chip--status" disableRipple>
          <mat-icon>filter_alt</mat-icon>
          {{ getSelectedStatusLabel() }}
        </mat-chip>
      </div>
    </mat-card-header>

    <mat-card-content class="prb-card__content">
      <div *ngIf="loading" class="prb-loading">
        <mat-spinner diameter="44"></mat-spinner>
        <div class="text">
          <h6 class="mb-0">Carregando dados</h6>
          <p class="mb-0">Aguarde um instante…</p>
        </div>
      </div>

      <div *ngIf="!loading && displayedColumns.length === 0" class="prb-empty">
        <mat-icon>info</mat-icon>
        <div>
          <h6 class="mb-0">Selecione pelo menos um campo</h6>
          <p class="mb-0">Assim você consegue visualizar e exportar o relatório.</p>
        </div>
      </div>

      <div *ngIf="!loading && displayedColumns.length > 0" class="prb-table">
        <table mat-table [dataSource]="professionals" class="w-100">
          <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
            <th mat-header-cell *matHeaderCellDef class="table-header">
              {{ getFieldHeader(column) }}
            </th>
            <td mat-cell *matCellDef="let professional" class="table-cell">
              {{ getValueForField(professional, column) }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="professionals.length === 0" class="prb-empty">
          <mat-icon>search_off</mat-icon>
          <div>
            <h6 class="mb-0">Nenhum profissional encontrado</h6>
            <p class="mb-0">Tente alterar o filtro de status.</p>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
